/**
 * The S14 disclosure (ADR-024): what a Company sees about the people who use
 * its portal. ONE text, shown on fias.io's Continue step and on the portal's
 * own sign-in page, and the version sent with the consent is the version this
 * component renders — never one read from the server, which could have moved
 * past what the visitor saw.
 *
 * Changing the text means bumping the version here AND
 * `COMPANY_WEB_DISCLOSURE_VERSION` in @fias/db-types (so existing consents are
 * asked again); tests/architecture/company-web-disclosure-parity.test.ts fails
 * until both move together.
 */
export const PORTAL_DISCLOSURE_VERSION = 2;

export function PortalDisclosure({ company }: { company: string }) {
  return (
    <>
      <strong>{company}</strong> will see your Fias username, display name, email address and when
      you use this portal. It will not see anything else in your account.
    </>
  );
}
